/**
 * Events module
 *
 * Module index file
 *
 * This file is used by theme to provide default functionality
 * to the module and to register all components.
 *
 * This file has to export setup function that will be called
 * automatically by import in the theme app.ts file.
 */

import { App } from 'vue';

import EventsUpcomingBlock from '@src/Events/Pages/Blocks/EventsUpcomingBlock.vue';
import LatestOrdersBlock from '@src/Events/Pages/Blocks/LatestOrdersBlock.vue';
import SynchronizationStatusBlock from '@src/Events/Pages/Blocks/SynchronizationStatusBlock.vue';

export const setup = (app: App<Element>): void => {
    app.component('EventsUpcomingBlock', EventsUpcomingBlock);
    app.component('LatestOrdersBlock', LatestOrdersBlock);
    app.component('SynchronizationStatusBlock', SynchronizationStatusBlock);
};
